import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import { UpgradeApiClientContext } from '../../upgrade.context';
import { getAvailableUpgradeCycles } from './utils';
export const fetchUpgradableCyclesQueryFn = async _ref => {
  let {
    httpClient
  } = _ref;
  const {
    getPurchaseUserOffering
  } = PremiumPurchasePlatformModule.SDK.ApiClient.queries({
    httpClient
  });
  const p3Context = UpgradeApiClientContext.get('p3Context');
  if (!p3Context) {
    throw new Error('P3 context is required to fetch upgradable cycles');
  }
  const getPurchaseUserOfferingResponse = await getPurchaseUserOffering({
    ...p3Context
  });
  const {
    products = []
  } = getPurchaseUserOfferingResponse;
  const availableCyclesByProductId = {};
  products.forEach(product => {
    if (!product.productId) {
      return;
    }
    const availableCycles = getAvailableUpgradeCycles(product);
    availableCyclesByProductId[product.productId] = availableCycles;
  });
  return availableCyclesByProductId;
};
//# sourceMappingURL=fetchUpgradableCycles.query.js.map